module.exports = __webpack_public_path__ + "static/media/RIASEC_Compass_v3.d8ac5e9e.png";